// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let RelayEnv = require("../../RelayEnv.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let Breadcrumbs = require("../common/Components/Breadcrumbs.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let ReasonPromise = require("../../reason/ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Utils__Promise = require("../../utils/Utils__Promise.bs.js");
let InputWithPrefix = require("../common/Components/InputWithPrefix.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__Debouncer = require("@tan/formality/src/Formality__Debouncer.bs.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let AgentMarketingProfileSlugFormQuery_graphql = require("../../__generated__/AgentMarketingProfileSlugFormQuery_graphql.bs.js");
let AgentMarketingProfileSlugFormMutation_graphql = require("../../__generated__/AgentMarketingProfileSlugFormMutation_graphql.bs.js");
let AgentMarketingProfileSlugFormValidationQuery_graphql = require("../../__generated__/AgentMarketingProfileSlugFormValidationQuery_graphql.bs.js");
let AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.bs.js");

let convertVariables = AgentMarketingProfileSlugFormValidationQuery_graphql.Internal.convertVariables;

let convertResponse = AgentMarketingProfileSlugFormValidationQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = AgentMarketingProfileSlugFormValidationQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, AgentMarketingProfileSlugFormValidationQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(AgentMarketingProfileSlugFormValidationQuery_graphql.node, convertVariables);

let ValidationQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let convertVariables$1 = AgentMarketingProfileSlugFormMutation_graphql.Internal.convertVariables;

let convertResponse$1 = AgentMarketingProfileSlugFormMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = AgentMarketingProfileSlugFormMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, AgentMarketingProfileSlugFormMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, AgentMarketingProfileSlugFormMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$1
};

let validators = {
  slug: {
    strategy: "OnFirstSuccessOrFirstBlur",
    validate: param => {
      let slug = param.slug;
      if (slug === "") {
        return {
          TAG: "Error",
          _0: "IsRequired"
        };
      } else {
        return {
          TAG: "Ok",
          _0: slug
        };
      }
    },
    validateAsync: Formality__Debouncer.make(700, param => {
      let dispatch = param[1];
      let value = param[0];
      let validate = slug => Utils__Promise.toJsPromise(ReasonPromise.map(ReasonPromise.map(Utils__Promise.fromJsPromise(fetchPromised(RelayEnv.environment, {
        slug: slug
      }, undefined, undefined)), v => {
        if (v.TAG !== "Ok") {
          return {
            TAG: "Error",
            _0: "GenericError"
          };
        }
        let result = v._0.marketingProfileSlugAvailability;
        if (result === undefined) {
          return {
            TAG: "Error",
            _0: "GenericError"
          };
        }
        switch (result.__typename) {
          case "SlugAvailable" :
            return {
              TAG: "Ok",
              _0: result.slug
            };
          case "SlugInvalid" :
            return {
              TAG: "Error",
              _0: {
                TAG: "SlugInvalid",
                suggestedSlug: result.suggestedSlug
              }
            };
          case "SlugUnavailable" :
            return {
              TAG: "Error",
              _0: "SlugUnavailable"
            };
          case "__unselected" :
            return {
              TAG: "Error",
              _0: "GenericError"
            };
        }
      }), e => ({
        TAG: "Ok",
        _0: e
      })));
      Formality.Async.validateAsync(value, validate, res => dispatch({
        TAG: "ApplyAsyncResultForSlugField",
        _0: value,
        _1: res
      }));
    }),
    eq: (a, b) => a === b
  }
};

function initialFieldsStatuses(input) {
  return {
    slug: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    slug: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      slug: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let value = fieldsStatuses.slug;
  let match;
  match = typeof value !== "object" ? ({
      NAME: "Result",
      VAL: validators.slug.validate(input)
    }) : (
      value.TAG === "Dirty" ? ({
          NAME: "Result",
          VAL: value._0
        }) : ({
          NAME: "Validating",
          VAL: value._0
        })
    );
  if (match.NAME !== "Result") {
    return {
      TAG: "Validating",
      fieldsStatuses: {
        slug: match.NAME === "Result" ? ({
            TAG: "Dirty",
            _0: match.VAL,
            _1: "Shown"
          }) : ({
            TAG: "Validating",
            _0: match.VAL
          })
      },
      collectionsStatuses: undefined
    };
  }
  let slugResult = match.VAL;
  if (slugResult.TAG === "Ok") {
    return {
      TAG: "Valid",
      output: {
        slug: slugResult._0
      },
      fieldsStatuses: {
        slug: {
          TAG: "Dirty",
          _0: slugResult,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  } else {
    return {
      TAG: "Invalid",
      fieldsStatuses: {
        slug: {
          TAG: "Dirty",
          _0: slugResult,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  }
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurSlugField" :
          let result = Formality.Async.validateFieldOfStringTypeOnBlur(state.input, state.fieldsStatuses.slug, validators.slug, status => ({
            slug: status
          }));
          if (result === undefined) {
            return "NoUpdate";
          }
          let value = result.slug;
          if (typeof value === "object" && value.TAG !== "Dirty") {
            let value$1 = value._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators.slug.validateAsync([
                value$1,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: result,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
          break;
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          switch (match$1.TAG) {
            case "Valid" :
              let output = match$1.output;
              let error = state.formStatus;
              let tmp;
              tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : Primitive_option.some(error._0);
              return {
                TAG: "UpdateWithSideEffects",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: {
                    TAG: "Submitting",
                    _0: tmp
                  },
                  submissionStatus: "AttemptedToSubmit"
                },
                _1: param => {
                  let dispatch = param.dispatch;
                  onSubmit(output, {
                    notifyOnSuccess: input => dispatch({
                      TAG: "SetSubmittedStatus",
                      _0: input
                    }),
                    notifyOnFailure: error => dispatch({
                      TAG: "SetSubmissionFailedStatus",
                      _0: error
                    }),
                    reset: () => dispatch("Reset"),
                    dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
                  });
                }
              };
            case "Invalid" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: "Editing",
                  submissionStatus: "AttemptedToSubmit"
                }
              };
            case "Validating" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: state.formStatus,
                  submissionStatus: state.submissionStatus
                }
              };
          }
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateSlugField" :
          let nextInput = action._0(state.input);
          let nextFieldsStatuses = Formality.Async.validateFieldOfStringTypeOnChangeInOnChangeMode(nextInput, state.fieldsStatuses.slug, state.submissionStatus, validators.slug, status => ({
            slug: status
          }));
          let value$2 = nextFieldsStatuses.slug;
          if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
            let value$3 = value$2._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: nextInput,
                fieldsStatuses: nextFieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators.slug.validateAsync([
                value$3,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: nextFieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "ApplyAsyncResultForSlugField" :
          let validator = validators.slug;
          let x = state.fieldsStatuses.slug;
          if (typeof x !== "object" || x.TAG === "Dirty" || !validator.eq(x._0, action._0)) {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  slug: {
                    TAG: "Dirty",
                    _0: action._1,
                    _1: "Shown"
                  }
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  slug: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  slug: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: Primitive_option.some(map(Primitive_option.valFromOption(error$2)))
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateSlug: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateSlugField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurSlug: () => dispatch("BlurSlugField"),
    slugResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.slug),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.slug;
      return typeof tmp === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      switch (match.TAG) {
        case "Valid" :
          return true;
        case "Invalid" :
          return false;
        case "Validating" :
          return;
      }
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let Config = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertFragment = AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$2,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "text-tan-error-500 font-medium"
  });
}

let $$Error = {
  make: AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error
};

function AgentMarketingProfileSlugForm$Form$SlugValidationMessage(props) {
  let result = props.result;
  if (result === undefined) {
    return null;
  }
  let updateSlug = props.updateSlug;
  if (result.TAG === "Validating") {
    return null;
  }
  let match = result._0;
  if (match.TAG === "Ok") {
    return JsxRuntime.jsx("div", {
      children: "This URL is available",
      className: "text-green-700 font-medium"
    });
  }
  let match$1 = match._0;
  if (typeof match$1 !== "object") {
    switch (match$1) {
      case "SlugUnavailable" :
        return JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error, {
          children: "This URL has already been taken"
        });
      case "GenericError" :
        return JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error, {
          children: "We're having problems validating your URL. Please try again later."
        });
      case "IsRequired" :
        return JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error, {
          children: "Is required"
        });
    }
  } else {
    let suggestedSlug = match$1.suggestedSlug;
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage$Error, {
          children: "This URL contains invalid characters."
        }),
        suggestedSlug !== undefined ? JsxRuntime.jsxs("div", {
            children: [
              "How about ",
              JsxRuntime.jsx("button", {
                children: suggestedSlug,
                className: "text-tan-blue-500 font-medium underline",
                onClick: param => updateSlug(suggestedSlug)
              }),
              "?"
            ]
          }) : null
      ],
      className: "space-y-1"
    });
  }
}

let SlugValidationMessage = {
  $$Error: $$Error,
  make: AgentMarketingProfileSlugForm$Form$SlugValidationMessage
};

function makeUrlPrefix(url) {
  let baseUrl = Scalars.URL.toWebapiUrl(url);
  return baseUrl.host + baseUrl.pathname + `/`;
}

function AgentMarketingProfileSlugForm$Form$SlugField(props) {
  let result = props.result;
  let status = Stdlib_Option.map(result, result => {
    if (result.TAG === "Validating") {
      return "validating";
    } else if (result._0.TAG === "Ok") {
      return "ok";
    } else {
      return "error";
    }
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Label.make, {
          labelText: "Personalize the URL for your profile"
        }),
        className: "pt-2"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(InputWithPrefix.make, {
            value: props.value,
            onChange: props.onChange,
            onBlur: props.onBlur,
            prefix: makeUrlPrefix(props.baseUrl),
            status: status
          }),
          JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugValidationMessage, {
            result: result,
            updateSlug: props.updateSlug
          })
        ],
        className: "mt-2 sm:col-span-2 sm:mt-0 sm:max-w-lg space-y-1"
      })
    ],
    className: "sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 pb-6 sm:py-6"
  });
}

let SlugField = {
  makeUrlPrefix: makeUrlPrefix,
  make: AgentMarketingProfileSlugForm$Form$SlugField
};

function AgentMarketingProfileSlugForm$Form(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(AgentMarketingProfileSlugForm_form_agentMarketingProfile_graphql.node, convertFragment, props.marketingProfile);
  let match = use$1();
  let mutate = match[0];
  let form = useForm({
    slug: marketingProfile.urlDetails.slug
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    mutate({
      input: {
        slug: param.slug
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let result = param.updateAgentMarketingProfileSlug;
      if (result === undefined) {
        return notifyOnFailure(undefined);
      }
      switch (result.__typename) {
        case "AgentMarketingProfileSlugUpdated" :
          return notifyOnSuccess(undefined);
        case "ProfileSettingsChangedError" :
          return notifyOnFailure(result.settingsChangedMessage);
        case "__unselected" :
          return notifyOnFailure(undefined);
      }
    }, param => notifyOnFailure(undefined), undefined);
  });
  let onInputChanged = React.useCallback(() => {
    let match = form.status;
    if (typeof match !== "object") {
      if (match === "Editing") {
        return;
      } else {
        return form.dismissSubmissionResult();
      }
    } else if (match.TAG === "Submitting") {
      return;
    } else {
      return form.dismissSubmissionResult();
    }
  }, [form.status]);
  React.useEffect(() => {
    onInputChanged();
  }, [form.input]);
  let message = form.status;
  let tmp;
  tmp = typeof message !== "object" ? (
      message === "Editing" ? null : JsxRuntime.jsx(Alert.Success.make, {
          title: "Your account was updated"
        })
    ) : (
      message.TAG === "Submitting" ? null : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Alert.$$Error.make, {
            title: Stdlib_Option.getOr(message._0, "There was an error updating your account. Please try again")
          }),
          className: "mt-4"
        })
    );
  return JsxRuntime.jsx("form", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form$SlugField, {
          onChange: event => form.updateSlug((_input, value) => ({
            slug: value
          }), event.target.value),
          value: form.input.slug,
          onBlur: param => form.blurSlug(),
          result: form.slugResult,
          updateSlug: x => form.updateSlug((_input, value) => ({
            slug: value
          }), x),
          baseUrl: marketingProfile.urlDetails.baseUrl
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                href: Scalars.URL.toString(marketingProfile.publicUrl),
                target: "_blank",
                children: "View Profile"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                    disabled: form.submitting,
                    children: "Save changes"
                  }),
                  JsxRuntime.jsx("div", {
                    children: tmp,
                    role: "status"
                  })
                ],
                className: "flex flex-col items-end gap-3"
              })
            ],
            className: "flex pt-4 justify-between items-baseline"
          })
        })
      ],
      className: "flex flex-col divide-y"
    }),
    onSubmit: event => {
      event.preventDefault();
      form.submit();
    }
  });
}

let Form = {
  ValidationQuery: ValidationQuery,
  Mutation: Mutation,
  Config: Config,
  Fragment: Fragment,
  SlugValidationMessage: SlugValidationMessage,
  SlugField: SlugField,
  make: AgentMarketingProfileSlugForm$Form
};

function AgentMarketingProfileSlugForm$Header(props) {
  let displayName = MarketingProfileSubpages.Page.Agent.useDisplayName();
  let breadcrumbs = [
    {
      name: "Marketing Profile",
      href: "/account/marketing_profile"
    },
    {
      name: displayName("Url"),
      href: MarketingProfileSubpages.Page.Agent.path("Url")
    }
  ];
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx(Breadcrumbs.make, {
        pages: breadcrumbs
      }),
      JsxRuntime.jsx("h2", {
        children: displayName("Url"),
        className: "text-zinc-800 text-3xl font-medium"
      })
    ],
    className: "space-y-3 border-b pb-2"
  });
}

let Header = {
  make: AgentMarketingProfileSlugForm$Header
};

let convertVariables$2 = AgentMarketingProfileSlugFormQuery_graphql.Internal.convertVariables;

let convertResponse$2 = AgentMarketingProfileSlugFormQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = AgentMarketingProfileSlugFormQuery_graphql.Internal.convertWrapRawResponse;

let use$3 = RescriptRelay_Query.useQuery(convertVariables$2, AgentMarketingProfileSlugFormQuery_graphql.node, convertResponse$2);

let useLoader$1 = RescriptRelay_Query.useLoader(convertVariables$2, AgentMarketingProfileSlugFormQuery_graphql.node, prim => prim);

let usePreloaded$1 = RescriptRelay_Query.usePreloaded(AgentMarketingProfileSlugFormQuery_graphql.node, convertResponse$2, prim => prim);

let fetch$1 = RescriptRelay_Query.fetch_(AgentMarketingProfileSlugFormQuery_graphql.node, convertResponse$2, convertVariables$2);

let fetchPromised$1 = RescriptRelay_Query.fetchPromised(AgentMarketingProfileSlugFormQuery_graphql.node, convertResponse$2, convertVariables$2);

let retain$1 = RescriptRelay_Query.retain(AgentMarketingProfileSlugFormQuery_graphql.node, convertVariables$2);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  use: use$3,
  useLoader: useLoader$1,
  usePreloaded: usePreloaded$1,
  fetch: fetch$1,
  fetchPromised: fetchPromised$1,
  retain: retain$1
};

function AgentMarketingProfileSlugForm(props) {
  let match = use$3(undefined, "network-only", undefined, undefined);
  let marketingProfile = match.currentAccountV5.marketingProfile;
  if (marketingProfile.__typename === "AgentMarketingProfile") {
    return JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(AgentMarketingProfileSlugForm$Header, {}),
          JsxRuntime.jsx(AgentMarketingProfileSlugForm$Form, {
            marketingProfile: marketingProfile.fragmentRefs
          })
        ],
        className: "space-y-8 sm:space-y-0"
      }),
      className: "bg-white p-6 shadow-sm rounded space-y-8"
    });
  } else {
    return UnselectedUnionMemberError.raise(`Unselected union member: ` + marketingProfile._0);
  }
}

let make = AgentMarketingProfileSlugForm;

exports.Form = Form;
exports.Header = Header;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
